import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = {
  class: "preset-entry-browser",
  "aria-label": "预设词条浏览"
}
const _hoisted_2 = { class: "browser-body" }
const _hoisted_3 = { class: "browser-search" }
const _hoisted_4 = { class: "browser-groups" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { class: "group-title" }
const _hoisted_7 = { class: "group-entries" }
const _hoisted_8 = ["title", "aria-current", "onClick"]
const _hoisted_9 = { class: "entry-label" }
const _hoisted_10 = {
  key: 0,
  class: "browser-empty",
  role: "status"
}

import { computed, ref, watch } from "vue";


export interface PresetBrowserEntry {
  id: string;
  label: string;
  detail?: string;
  system: boolean;
}
export interface PresetBrowserGroup {
  key: string;
  title: string;
  entries: PresetBrowserEntry[];
}
export interface PresetBrowserSelection { category: string; id: string }

export default /*@__PURE__*/_defineComponent({
  __name: 'PresetEntryBrowser',
  props: {
    groups: {},
    activeCategory: {},
    selectedEntry: {},
    collapsed: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const query = ref("");
const search = computed(() => query.value.trim().toLocaleLowerCase());
const activeGroup = computed(() => props.groups.find(group => group.key === props.activeCategory));
const filteredEntries = computed(() => (activeGroup.value?.entries ?? []).filter(entry => !search.value
    || entry.label.toLocaleLowerCase().includes(search.value)
    || entry.detail?.toLocaleLowerCase().includes(search.value)));
const entrySections = computed(() => [
  { key: "system", title: "系统默认", entries: filteredEntries.value.filter(entry => entry.system) },
  { key: "custom", title: "自定义", entries: filteredEntries.value.filter(entry => !entry.system) },
].filter(section => section.entries.length > 0));
watch(() => props.activeCategory, () => { query.value = ""; });
const isSelected = (category: string, id: string) => props.selectedEntry?.category === category && props.selectedEntry.id === id;

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("svg", {
          viewBox: "0 0 20 20",
          width: "16",
          height: "16",
          "aria-hidden": "true"
        }, [
          _createElementVNode("circle", {
            cx: "8.5",
            cy: "8.5",
            r: "5"
          }),
          _createElementVNode("path", { d: "m12.3 12.3 4.2 4.2" })
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
          type: "search",
          "aria-label": "搜索词条或代号",
          placeholder: "搜索代号"
        }, null, 512), [
          [_vModelText, query.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entrySections.value, (section) => {
          return (_openBlock(), _createElementBlock("section", {
            key: section.key,
            class: "browser-group",
            "aria-label": section.title
          }, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(section.title), 1),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.entries, (entry) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: entry.id,
                  type: "button",
                  class: "entry-button",
                  title: entry.label || '未命名词条',
                  "aria-current": isSelected(__props.activeCategory, entry.id) ? 'true' : undefined,
                  onClick: ($event: any) => (emit('select', __props.activeCategory, entry.id))
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(entry.label || '未命名词条'), 1)
                ], 8, _hoisted_8))
              }), 128))
            ])
          ], 8, _hoisted_5))
        }), 128)),
        (!filteredEntries.value.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(search.value ? '未找到匹配的词条或代号。' : '暂无可浏览的词条。'), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512)), [
    [_vShow, !__props.collapsed]
  ])
}
}

})